import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import Toastify from 'toastify-js'

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

$(function () {
    // Animation
    let defaultEase = "circ.inOut";

    function loadAnimation() {
        setTimeout(() => {
            if ($(".appointment-page .message-item").length) {
                gsap.to(".appointment-page .message-item", {
                    opacity: 1,
                    delay: 0.6,
                    duration: 1,
                    ease: defaultEase
                })
            }

            // Success
            gsap.to(".appointment-page.appointment-success-page .appointment-container .appointment-sidebar .circle-blur", {
                scale: 1,
                delay: 0.6,
                duration: 1,
                ease: defaultEase
            })

            gsap.to(".appointment-page.appointment-success-page .appointment-container .appointment-sidebar .content-btn", {
                opacity: 1,
                delay: 0.6,
                duration: 0.8,
                ease: defaultEase
            })

            // Sidebar
            gsap.to(".appointment-page .appointment-container .appointment-sidebar .appointment-card", {
                y: 0,
                opacity: 1,
                delay: 0.6,
                duration: 0.8,
                ease: defaultEase
            })

            gsap.to(".appointment-page .appointment-container .appointment-sidebar .sidebar-info span", {
                y: 0,
                opacity: 1,
                delay: 0.6,
                duration: 0.8,
                ease: defaultEase
            })

            gsap.to(".appointment-page .appointment-container .appointment-sidebar .sidebar-info p", {
                y: 0,
                opacity: 1,
                delay: 0.6,
                duration: 0.8,
                ease: defaultEase
            })

            // Content
            gsap.to(".appointment-page .appointment-container .appointment-content .item-event-btn", {
                y: 0,
                opacity: 1,
                delay: 0.6,
                duration: 0.8,
                ease: defaultEase
            })

            gsap.to(".appointment-page .appointment-container .appointment-content .item-title", {
                y: 0,
                opacity: 1,
                stagger: 0.1,
                delay: 0.6,
                duration: 0.8,
                ease: defaultEase
            })

            gsap.to(".appointment-page .appointment-container .appointment-content .form-item", {
                y: 0,
                opacity: 1,
                stagger: 0.1,
                delay: 0.6,
                duration: 0.8,
                ease: defaultEase
            })

            // gsap.to(".appointment-page .appointment-container .appointment-content .appointment-doctors-slide", {
            //     opacity: 1,
            //     y: 0,
            //     delay: 0.7,
            //     duration: 0.8,
            //     ease: defaultEase
            // })

            gsap.to(".appointment-page .appointment-container .appointment-content .doctor-item", {
                opacity: 1,
                stagger: 0.1,
                delay: 0.7,
                duration: 0.8,
                ease: defaultEase
            })

            gsap.to(".appointment-page .appointment-container .appointment-content", {
                opacity: 1,
                y: 0,
                stagger: 0.1,
                delay: 0.7,
                duration: 0.8,
                ease: defaultEase
            })
        }, 500);
    }

    if ($(window).width() >= 1200) {
        loadAnimation();
    }

    $(window).resize(function () {
        if ($(window).width() >= 1200) {
            loadAnimation();
        }
    });

    if ($(".appointment-page").length) {
        // Date Picker
        let dateCheck = "";

        function datePicker(dates) {
            var unavailableDates = dates;

            function unavailable(date) {
                let dmy = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
                if ($.inArray(dmy, unavailableDates) == -1) {
                    return [true, ""];
                } else {
                    return [false, "", "Unavailable"];
                }
            }

            $('#datepicker').remove()

            setTimeout(() => {
                $('.appointment-page .content-item-date .datepicker-container').append('<div id="datepicker"></div>')

                gsap.to(".appointment-page .appointment-container .appointment-content #datepicker", {
                    opacity: 1,
                    y: 0,
                    delay: 0.1,
                    duration: 0.8,
                    ease: defaultEase
                })

                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0');
                var yyyy = today.getFullYear();
                today = yyyy + '-' + dd + '-' + mm;

                $('.appointment-page .content-item-date > input').val(today)

                if ($('#datepicker').length) {
                    let dayArray = []
                    let monthNamesArray = []

                    if ($("html").attr("lang") == "en-US") {
                        dayArray = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
                        monthNamesArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
                    } else if ($("html").attr("lang") == "tr-TR") {
                        dayArray = ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts']
                        monthNamesArray = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"]
                    }

                    $('#datepicker').datepicker({
                        inline: true,
                        showOtherMonths: true,
                        minDate: new Date(),
                        monthNames: monthNamesArray,
                        dayNamesMin: dayArray,
                        firstDay: 1,
                        beforeShowDay: unavailable,
                        onSelect: function (date) {
                            dateCheck = date

                            $('.appointment-page .content-item-date > input').val(dateCheck.split("/")[2] + "-" + dateCheck.split("/")[0] + "-" + dateCheck.split("/")[1])
                            $(".appointment-page .appointment-card .card-container .card-item:nth-child(3) .card-row > span").text(dateCheck.split("/")[1] + "." + dateCheck.split("/")[0] + "." + dateCheck.split("/")[2])
                            $(".appointment-page .appointment-card .card-container .card-item:nth-child(3) .card-row .skeleton-load").fadeOut()

                            // Step 4
                            // $(".appointment-page .sidebar-menu ul li:nth-child(4)").removeClass("in-active")
                            // $(".appointment-page .appointment-content .content-item:nth-child(4)").removeClass("in-active")

                            // $(".appointment-page .appointment-content button").removeClass("in-active")

                            // if (userTCCheck !== "") {
                            //     if (userTCCheck > 0) {
                            //         $(".appointment-page .appointment-content button").removeClass("in-active")
                            //     } else {
                            //         $(".appointment-page .appointment-content button").addClass("in-active")
                            //     }
                            // } else {
                            //     $(".appointment-page .appointment-content button").removeClass("in-active")
                            // }
                        }
                    });
                }
            }, 100);
        }

        datePicker([])

        $(".appointment-page .content-item .item-doctors .doctor-item").click(function () {
            let dataDates = $(this).data("dates")
            datePicker(dataDates)
        })

        // User Info Validation
        let userName = "";
        let userTC = "";
        let userTCCheck = false;
        let userEmail = "";
        let userPhone = "";
        let doctorCheck = false;

        let userNameVal = $(".appointment-page .appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(1) input").val();
        if (userNameVal !== "") {
            userName = userNameVal;
            $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(1) > span").text(userNameVal)
            $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(1) .skeleton-load").fadeOut()
        }

        $(".appointment-page .appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(1) input").keyup(function (e) {
            userName = $(this).val()

            $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(1) > span").text(userName)

            if (userName !== "") {
                $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(1) .skeleton-load").fadeOut()
            } else {
                $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(1) .skeleton-load").fadeIn()
            }

            // validationStep2()
        })

        let userTCVal = $(".appointment-page .appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(2) input").val();
        if (userTCVal !== "") {
            userTC = userTCVal;

            const re = /^[0-9]{11}$/;
            if (re.test(userTCVal.trim())) {
                userTC = userTCVal.length
                // validationTC()
            } else {
                userTC = 0
                // validationTC()
            }

            $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(1) > span").text(userTC)
            $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(1) .skeleton-load").fadeOut()
        }

        $(".appointment-page .appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(2) input").keyup(function (e) {
            userTC = $(this).val()

            const re = /^[0-9]{11}$/;
            if ($(this).val() !== "") {
                if (re.test($(this).val().trim())) {
                    userTC = $(this).val().length
                    // validationTC()
                } else {
                    userTC = 0
                    // validationTC()
                }
            }

            if ($(this).val() === "") {
                userTC = ""
            }

            $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(1) > span").text($(this).val())

            if (userTC !== "") {
                $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(1) .skeleton-load").fadeOut()
            } else {
                $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(1) .skeleton-load").fadeIn()
            }
        })

        let userEmailVal = $(".appointment-page .appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(3) input").val();
        if (userEmailVal !== "") {
            userEmail = userEmailVal;

            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (re.test(userEmailVal.trim())) {
                userEmail = userEmailVal.length
            } else {
                userEmail = 0
            }

            $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(2) > span").text(userEmailVal)
            $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(2) .skeleton-load").fadeOut()
        }

        $(".appointment-page .appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(3) input").keyup(function (e) {
            userEmail = $(this).val()

            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (re.test($(this).val().trim())) {
                userEmail = $(this).val().length
            } else {
                userEmail = 0
            }

            if ($(this).val() === "") {
                userEmail = ""
            }

            $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(2) > span").text($(this).val())

            if (userEmail !== "") {
                $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(2) .skeleton-load").fadeOut()
            } else {
                $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(2) .skeleton-load").fadeIn()
            }
        })

        let userPhoneVal = $(".appointment-page .appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(4) input").val();
        if (userPhoneVal !== "") {
            userPhone = userPhoneVal;

            const re = /^\+?[0-9]/;
            if (re.test(userPhoneVal.trim())) {
                userPhone = userPhoneVal.length
            } else {
                userPhone = 0
            }

            $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(2) > span").text(userPhoneVal)
            $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(2) .skeleton-load").fadeOut()
        }

        $(".appointment-page .appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(4) input").keyup(function (e) {
            userPhone = $(this).val()

            const re = /^\+?[0-9]/;
            if ($(this).val() !== "") {
                if (re.test($(this).val().trim())) {
                    userPhone = $(this).val().length
                } else {
                    userPhone = 0
                }
            }

            if ($(this).val() === "") {
                userPhone = ""
            }

            $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(2) > span").text($(this).val())

            if (userPhone !== "") {
                $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(2) .skeleton-load").fadeOut()
            } else {
                $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(2) .skeleton-load").fadeIn()
            }
        })

        let messageVal = $(".appointment-page .appointment-content .content-item:nth-child(4) textarea").val();
        if (messageVal !== "") {
            $(".appointment-page .appointment-card .card-container .card-item:nth-child(4) .card-row > span").text(messageVal)
            $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(4)").addClass("active")
            $(".appointment-page .appointment-card .card-container .card-item:nth-child(4) .card-row .skeleton-load").fadeOut()
        }

        $(".appointment-page .appointment-content .content-item:nth-child(4) textarea").keyup(function (e) {
            $(".appointment-page .appointment-card .card-container .card-item:nth-child(4) .card-row > span").text($(this).val())

            if ($(this).val() !== "") {
                $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(4)").addClass("active")
                $(".appointment-page .appointment-card .card-container .card-item:nth-child(4) .card-row .skeleton-load").fadeOut()
            } else {
                $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(4)").removeClass("active")
                $(".appointment-page .appointment-card .card-container .card-item:nth-child(4) .card-row .skeleton-load").fadeIn()
            }
        })

        function validationStep2() {
            if (userName !== "" && userEmail !== "" && userPhone !== "") {
                // Step 2
                $(".appointment-page .appointment-content .content-item:nth-child(2)").removeClass("in-active")

                if (doctorCheck) {
                    // Step 3
                    $(".appointment-page .appointment-content .content-item:nth-child(3)").removeClass("in-active")
                }

                if (dateCheck !== "") {
                    // Step 4
                    $(".appointment-page .appointment-content .content-item:nth-child(4)").removeClass("in-active")
                }
            } else {
                // Step 2
                $(".appointment-page .appointment-content .content-item:nth-child(2)").addClass("in-active")

                // Step 3
                $(".appointment-page .appointment-content .content-item:nth-child(3)").addClass("in-active")

                // Step 4
                $(".appointment-page .appointment-content .content-item:nth-child(4)").addClass("in-active")

                $(".appointment-page .appointment-content button").addClass("in-active")
            }
        }

        function validationTC() {
            if (userTC === "") {
                userTCCheck = "";
            } else {
                if (userTC > 0) {
                    userTCCheck = true;
                } else {
                    userTCCheck = false;
                }
            }

            // if (dateCheck) {
            //     if (userTCCheck === "") {
            //         $(".appointment-page .appointment-content button").removeClass("in-active")
            //     } else {
            //         if (userTCCheck > 0) {
            //             $(".appointment-page .appointment-content button").removeClass("in-active")
            //         } else {
            //             $(".appointment-page .appointment-content button").addClass("in-active")
            //         }
            //     }
            // }
        }

        // Doctors Validation & Filters
        $(".appointment-page .appointment-content .content-item:nth-child(2) .item-doctors .doctor-item").click(function (e) {
            doctorCheck = true

            let drTitle = $(this).find("label > div > span:nth-child(1)").text();
            let drName = $(this).find("label > div > span:nth-child(2)").text();
            let drImgSrc = $(this).find("label > img").attr("src");
            let drImgTitle = $(this).find("label > img").attr("title");
            let categoryTitle = $(this).find("label").data("category");
            let drHospital = $(this).find("label").data("hospital");

            $(".appointment-card .card-container .card-item.doctor-item .card-img .img img").attr("src", drImgSrc)
            $(".appointment-card .card-container .card-item.doctor-item .card-img .img img").attr("title", drImgTitle)

            $(".appointment-card .card-container .card-item.doctor-item .card-img .dr-text > span:nth-child(1)").text(drTitle)
            $(".appointment-card .card-container .card-item.doctor-item .card-img .dr-text > span:nth-child(2)").text(drName)

            $(".appointment-card .card-container .card-item.doctor-item .card-row .card-text > span").text(categoryTitle)

            $(".appointment-card .card-container .card-item:nth-child(5) .card-row > span").text(drHospital)
            $(".appointment-card .card-container .card-item:nth-child(5) .card-row .skeleton-load").fadeOut()

            $(".appointment-card .card-container .card-item.doctor-item .skeleton-load").fadeOut()
            $(".appointment-card .card-container .card-item.doctor-item .card-img .img").addClass("active")

            // Step 3
            // $(".appointment-page .sidebar-menu ul li:nth-child(3)").removeClass("in-active")
            // $(".appointment-page .appointment-content .content-item:nth-child(3)").removeClass("in-active")
        })

        setTimeout(() => {
            $(".doctor-select .nice-select .option").click(function () {
                let optionValue = $(this).data("value")

                $(".appointment-content .item-doctors-container").each(function () {
                    if (optionValue == $(this).data("category")) {
                        setTimeout(() => {
                            $(this).fadeIn()
                        }, 400);
                    } else {
                        $(this).fadeOut()
                    }
                });
            });
        }, 500);

        // let doctorsSlide = new Swiper('.appointment-doctors-slide .swiper', {
        //     slidesPerView: "auto",
        //     spaceBetween: 20,
        //     freeMode: true,
        // });

        // doctorsSlide.on("transitionEnd", function () {
        //     let itemIndex = $(".appointment-doctors-slide .swiper-slide-active").index();
        //     $(".appointment-doctors-slide .swiper-slide-active .categorie-item").addClass("active")
        //     $(".appointment-doctors-slide .swiper-slide-active").siblings().children().removeClass("active")

        //     $(".appointment-content .tab-content-container .tab-content").each(function (index) {
        //         if (itemIndex == index) {
        //             gsap.to($(this).parent(), {
        //                 height: $(this).height(),
        //                 duration: 0.6,
        //                 ease: defaultEase,
        //             })

        //             gsap.to($(this), {
        //                 y: 0,
        //                 autoAlpha: 1,
        //                 duration: 0.6,
        //                 ease: defaultEase,
        //             })
        //         } else {
        //             gsap.to($(this), {
        //                 y: 20,
        //                 autoAlpha: 0,
        //                 duration: 0.1,
        //                 ease: defaultEase,
        //             })
        //         }
        //     });
        // })

        // let firstItemHeight = $(".appointment-content .tab-content-container .tab-content:first-child").height();
        // $(".appointment-content .tab-content-container").css("height", firstItemHeight + "px")

        // $(".appointment-doctors-slide .categorie-item").click(function () {
        //     let itemIndex = $(this).parent().index();

        //     $(".appointment-doctors-slide .categorie-item").addClass("pointer-none");
        //     setTimeout(() => {
        //         $(".appointment-doctors-slide .categorie-item").removeClass("pointer-none");
        //     }, 700);

        //     $(this).addClass("active").parent().siblings().children().removeClass("active")

        //     $(".appointment-content .tab-content-container .tab-content").each(function (index) {
        //         if (itemIndex == index) {
        //             gsap.to($(this).parent(), {
        //                 height: $(this).height(),
        //                 duration: 0.6,
        //                 ease: defaultEase,
        //             })

        //             gsap.to($(this), {
        //                 y: 0,
        //                 autoAlpha: 1,
        //                 duration: 0.6,
        //                 ease: defaultEase,
        //             })
        //         } else {
        //             gsap.to($(this), {
        //                 y: 20,
        //                 autoAlpha: 0,
        //                 duration: 0.1,
        //                 ease: defaultEase,
        //             })
        //         }
        //     });
        // });

        // Step
        let containerY;

        if (window.innerWidth >= 1200) {
            if (window.innerHeight < 660) {
                containerY = parseInt($(".appointment-content .content-container").css("transform").split(",")[5].split(")")[0]) - 30;
            } else if (window.innerHeight < 800) {
                containerY = parseInt($(".appointment-content .content-container").css("transform").split(",")[5].split(")")[0]) - 60;
            } else if (window.innerHeight < 830) {
                containerY = parseInt($(".appointment-content .content-container").css("transform").split(",")[5].split(")")[0]) - 40;
            } else {
                containerY = parseInt($(".appointment-content .content-container").css("transform").split(",")[5].split(")")[0]) - 20;
            }
        } else {
            $(".appointment-content .content-container").css("height", $(".appointment-content .content-container .content-item:nth-child(1)").height() + "px")

            gsap.to(".appointment-content .content-container .content-item:nth-child(1)", {
                opacity: 1,
                duration: 0.3,
                ease: defaultEase,
            })
        }

        $(".appointment-content .content-item:nth-child(1) .item-event-btn .btn").click(function () {
            if ($(this).hasClass("btn-next")) {
                if (userName === "") {
                    Toastify({
                        text: $(".appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(1)").data("message-text"),
                        duration: 2000,
                        newWindow: true,
                        close: true,
                        gravity: "bottom",
                        position: "right",
                    }).showToast();
                }

                if (userTC !== "") {
                    if (userTC === 0) {
                        Toastify({
                            text: $(".appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(2)").data("message-text"),
                            duration: 2000,
                            newWindow: true,
                            close: true,
                            gravity: "bottom",
                            position: "right",
                        }).showToast();
                    }
                }

                if (userEmail !== "") {
                    if (userEmail === 0) {
                        Toastify({
                            text: $(".appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(3)").data("message-text"),
                            duration: 2000,
                            newWindow: true,
                            close: true,
                            gravity: "bottom",
                            position: "right",
                        }).showToast();
                    }
                }

                if (userPhone !== "") {
                    if (userPhone === 0) {
                        Toastify({
                            text: $(".appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(4)").data("message-text"),
                            duration: 2000,
                            newWindow: true,
                            close: true,
                            gravity: "bottom",
                            position: "right",
                        }).showToast();
                    }
                }

                if (userEmail === "" && userPhone === "") {
                    Toastify({
                        text: $(".appointment-content .content-item:nth-child(1) .item-container .form-item:nth-child(3)").data("message-group-text"),
                        duration: 2000,
                        newWindow: true,
                        close: true,
                        gravity: "bottom",
                        position: "right",
                    }).showToast();
                }

                if (userName !== "" && userTC !== 0 && userEmail !== 0 && userPhone !== 0 && (userEmail !== "" || userPhone !== "")) {
                    $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(1)").addClass("active")
                    $(".appointment-content .content-item:nth-child(1)").addClass("point-none")
                    $(".appointment-content .content-item:nth-child(2)").addClass("active")

                    if (window.innerWidth >= 1200) {
                        gsap.to(".appointment-content .content-container", {
                            y: -($(".appointment-content .content-item:nth-child(1)").height() - containerY),
                            duration: 0.8,
                            ease: defaultEase,
                        })
                    } else {
                        gsap.to(".appointment-content .content-container .content-item:nth-child(1)", {
                            yPercent: -110,
                            duration: 0.8,
                            ease: defaultEase,
                        })

                        gsap.fromTo(".appointment-content .content-container .content-item:nth-child(2)", {
                            yPercent: 80,
                            opacity: 0,
                        }, {
                            yPercent: 0,
                            opacity: 1,
                            duration: 0.8,
                            ease: defaultEase,
                        })

                        $(".appointment-content .content-item:nth-child(1)").removeClass("active")
                        gsap.to(".appointment-content .content-container", {
                            height: $(".appointment-content .content-container .content-item:nth-child(2)").height(),
                            duration: 0.8,
                            ease: defaultEase,
                        })
                    }

                    if (userTC === "") {
                        $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(1) .skeleton-load").fadeOut()
                    }

                    if (userEmail === "") {
                        $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(2) .skeleton-load").fadeOut()
                    }

                    if (userPhone === "") {
                        $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(2) .skeleton-load").fadeOut()
                    }
                }
            }
        })

        $(".appointment-content .content-item:nth-child(2) .item-event-btn .btn").click(function () {
            if ($(this).hasClass("btn-prev")) {
                $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(1)").removeClass("active")
                $(".appointment-content .content-item:nth-child(1)").removeClass("point-none")
                $(".appointment-content .content-item:nth-child(2)").removeClass("active")

                if (window.innerWidth >= 1200) {
                    gsap.to(".appointment-content .content-container", {
                        y: containerY,
                        duration: 0.8,
                        ease: defaultEase,
                    })
                } else {
                    gsap.to(window, { duration: 0.4, scrollTo: 0 })

                    gsap.fromTo(".appointment-content .content-container .content-item:nth-child(1)", {
                        yPercent: -110,
                        opacity: 0,
                    }, {
                        yPercent: 0,
                        delay: 0.1,
                        opacity: 1,
                        duration: 0.8,
                        ease: defaultEase,
                    })

                    gsap.fromTo(".appointment-content .content-container .content-item:nth-child(2)", {
                        yPercent: 0,
                        opacity: 1,
                    }, {
                        yPercent: 80,
                        opacity: 0,
                        duration: 0.8,
                        ease: defaultEase,
                    })

                    $(".appointment-content .content-item:nth-child(1)").addClass("active")
                    gsap.to(".appointment-content .content-container", {
                        height: $(".appointment-content .content-container .content-item:nth-child(1)").height(),
                        duration: 0.8,
                        ease: defaultEase,
                    })
                }

                if (userTC === "") {
                    $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(1) .skeleton-load").fadeIn()
                }

                if (userEmail === "") {
                    $(".appointment-page .card-container .card-item.name-item .card-row .card-text > span:nth-child(2) .skeleton-load").fadeIn()
                }

                if (userPhone === "") {
                    $(".appointment-page .card-container .card-item.name-item .card-row .card-text .text-row > span:nth-child(2) .skeleton-load").fadeIn()
                }
            }

            if ($(this).hasClass("btn-next")) {
                if (doctorCheck === false) {
                    Toastify({
                        text: $(".appointment-content .content-item:nth-child(2)").data("message-text"),
                        duration: 2000,
                        newWindow: true,
                        close: true,
                        gravity: "bottom",
                        position: "right",
                    }).showToast();
                } else {
                    $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(5)").addClass("active")
                    $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(2)").addClass("active")
                    $(".appointment-content .content-item:nth-child(2)").addClass("point-none")
                    $(".appointment-content .content-item:nth-child(3)").addClass("active")

                    if (window.innerWidth >= 1200) {
                        gsap.to(".appointment-content .content-container", {
                            y: -(($(".appointment-content .content-item:nth-child(1)").height() * 2) - containerY),
                            duration: 0.8,
                            ease: defaultEase,
                        })
                    } else {
                        gsap.to(window, { duration: 0.4, scrollTo: 0 })

                        gsap.fromTo(".appointment-content .content-container .content-item:nth-child(1)", {
                            opacity: 1,
                        }, {
                            opacity: 0,
                            duration: 0.8,
                            ease: defaultEase,
                        })

                        gsap.fromTo(".appointment-content .content-container .content-item:nth-child(2)", {
                            yPercent: 0,
                        }, {
                            yPercent: -110,
                            duration: 0.8,
                            ease: defaultEase,
                        })

                        gsap.fromTo(".appointment-content .content-container .content-item:nth-child(3)", {
                            yPercent: 80,
                            opacity: 0,
                        }, {
                            yPercent: 0,
                            opacity: 1,
                            delay: 0.1,
                            duration: 0.8,
                            ease: defaultEase,
                        })

                        $(".appointment-content .content-item:nth-child(2)").removeClass("active")
                        gsap.to(".appointment-content .content-container", {
                            height: $(".appointment-content .content-container .content-item:nth-child(3)").height(),
                            duration: 0.8,
                            ease: defaultEase,
                        })
                    }
                }
            }
        })

        $(".appointment-content .content-item:nth-child(3) .item-event-btn .btn").click(function () {
            if ($(this).hasClass("btn-prev")) {
                $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(5)").removeClass("active")
                $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(2)").removeClass("active")
                $(".appointment-content .content-item:nth-child(2)").removeClass("point-none")
                $(".appointment-content .content-item:nth-child(3)").removeClass("active")

                if (window.innerWidth >= 1200) {
                    gsap.to(".appointment-content .content-container", {
                        y: -($(".appointment-content .content-item:nth-child(1)").height() - containerY),
                        duration: 0.8,
                        ease: defaultEase,
                    })
                } else {
                    gsap.fromTo(".appointment-content .content-container .content-item:nth-child(2)", {
                        opacity: 0,
                        yPercent: -110,
                    }, {
                        yPercent: 0,
                        delay: 0.1,
                        opacity: 1,
                        duration: 0.8,
                        ease: defaultEase,
                    })

                    gsap.fromTo(".appointment-content .content-container .content-item:nth-child(3)", {
                        yPercent: 0,
                        opacity: 1,
                    }, {
                        yPercent: 80,
                        opacity: 0,
                        duration: 0.8,
                        ease: defaultEase,
                    })

                    $(".appointment-content .content-item:nth-child(2)").addClass("active")
                    gsap.to(".appointment-content .content-container", {
                        height: $(".appointment-content .content-container .content-item:nth-child(2)").height(),
                        duration: 0.8,
                        ease: defaultEase,
                    })
                }
            }

            if ($(this).hasClass("btn-next")) {
                if (!dateCheck) {
                    Toastify({
                        text: $(".appointment-content .content-item:nth-child(3)").data("message-text"),
                        duration: 2000,
                        newWindow: true,
                        close: true,
                        gravity: "bottom",
                        position: "right",
                    }).showToast();
                }
                else {
                    $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(3)").addClass("active")
                    $(".appointment-content .content-item:nth-child(3)").addClass("point-none")
                    $(".appointment-content .content-item:nth-child(4)").addClass("active")

                    if (window.innerWidth >= 1200) {
                        gsap.to(".appointment-content .content-container", {
                            y: -(($(".appointment-content .content-item:nth-child(1)").height() * 3) - containerY),
                            duration: 0.8,
                            ease: defaultEase,
                        })
                    } else {
                        gsap.fromTo(".appointment-content .content-container .content-item:nth-child(2)", {
                            opacity: 1,
                        }, {
                            opacity: 0,
                            duration: 0.8,
                            ease: defaultEase,
                        })

                        gsap.fromTo(".appointment-content .content-container .content-item:nth-child(3)", {
                            yPercent: 0,
                        }, {
                            yPercent: -110,
                            duration: 0.8,
                            ease: defaultEase,
                        })

                        gsap.fromTo(".appointment-content .content-container .content-item:nth-child(4)", {
                            yPercent: 80,
                            opacity: 0,
                        }, {
                            yPercent: 0,
                            opacity: 1,
                            duration: 0.8,
                            delay: 0.1,
                            ease: defaultEase,
                        })

                        $(".appointment-content .content-item:nth-child(3)").removeClass("active")
                        gsap.to(".appointment-content .content-container", {
                            height: $(".appointment-content .content-container .content-item:nth-child(4)").height(),
                            duration: 0.8,
                            ease: defaultEase,
                        })
                    }
                }
            }
        })

        $(".appointment-content .content-item:nth-child(4) .item-event-btn .btn").click(function () {
            if ($(this).hasClass("btn-prev")) {
                $(".appointment-sidebar .appointment-card .card-container .card-item:nth-child(3)").removeClass("active")
                $(".appointment-content .content-item:nth-child(3)").removeClass("point-none")
                $(".appointment-content .content-item:nth-child(4)").removeClass("active")

                if (window.innerWidth >= 1200) {
                    gsap.to(".appointment-content .content-container", {
                        y: -(($(".appointment-content .content-item:nth-child(1)").height() * 2) - containerY),
                        duration: 0.8,
                        ease: defaultEase,
                    })
                } else {
                    gsap.fromTo(".appointment-content .content-container .content-item:nth-child(3)", {
                        yPercent: -110,
                    }, {
                        delay: 0.1,
                        yPercent: 0,
                        duration: 0.8,
                        ease: defaultEase,
                    })

                    gsap.fromTo(".appointment-content .content-container .content-item:nth-child(4)", {
                        yPercent: 0,
                        opacity: 1,
                    }, {
                        yPercent: 80,
                        opacity: 0,
                        duration: 0.8,
                        ease: defaultEase,
                    })

                    $(".appointment-content .content-item:nth-child(3)").addClass("active")
                    gsap.to(".appointment-content .content-container", {
                        height: $(".appointment-content .content-container .content-item:nth-child(3)").height(),
                        duration: 0.8,
                        ease: defaultEase,
                    })
                }
            }
        })

        // Mobile Button
        $(".appointment-page .appointment-container .appointment-card-btn").click(function () {
            $(".appointment-page .appointment-container .appointment-sidebar .appointment-card-container").addClass("active")
        });

        $(".appointment-page .appointment-container .appointment-sidebar .appointment-card-container .item-close").click(function () {
            $(".appointment-page .appointment-container .appointment-sidebar .appointment-card-container").removeClass("active")
        });

        if ($(window).width() < 1199) {
            let footerOffset = $("footer").offset().top;
            $(window).scroll(function () {
                if (($(this).scrollTop() + $(window).height() - 300) > footerOffset) {
                    $(".appointment-card-btn").hide()
                } else {
                    $(".appointment-card-btn").show()
                }
            });
        }

        // Form Valid
        $(".appointment-page .appointment-content form").submit(function () {
            if (userName === "") {
                Toastify({
                    text: $(this).find(".content-item:nth-child(1) .item-container .form-item:nth-child(1)").data("message-text"),
                    duration: 2000,
                    newWindow: true,
                    close: true,
                    gravity: "bottom",
                    position: "right",
                }).showToast();
                return false;
            }

            if (userTC !== "") {
                if (userTC === 0) {
                    Toastify({
                        text: $(this).find(".content-item:nth-child(1) .item-container .form-item:nth-child(2)").data("message-text"),
                        duration: 2000,
                        newWindow: true,
                        close: true,
                        gravity: "bottom",
                        position: "right",
                    }).showToast();
                    return false;
                }
            }

            if (userEmail !== "") {
                if (userEmail === 0) {
                    Toastify({
                        text: $(this).find(".content-item:nth-child(1) .item-container .form-item:nth-child(3)").data("message-text"),
                        duration: 2000,
                        newWindow: true,
                        close: true,
                        gravity: "bottom",
                        position: "right",
                    }).showToast();
                    return false;
                }
            }

            if (userPhone !== "") {
                if (userPhone === 0) {
                    Toastify({
                        text: $(this).find(".content-item:nth-child(1) .item-container .form-item:nth-child(4)").data("message-text"),
                        duration: 2000,
                        newWindow: true,
                        close: true,
                        gravity: "bottom",
                        position: "right",
                    }).showToast();
                    return false;
                }
            }

            if (userEmail === "" && userPhone === "") {
                Toastify({
                    text: $(this).find(".content-item:nth-child(1) .item-container .form-item:nth-child(3)").data("message-group-text"),
                    duration: 2000,
                    newWindow: true,
                    close: true,
                    gravity: "bottom",
                    position: "right",
                }).showToast();
                return false;
            }

            if (doctorCheck === false) {
                Toastify({
                    text: $(this).find(".content-item:nth-child(2)").data("message-text"),
                    duration: 2000,
                    newWindow: true,
                    close: true,
                    gravity: "bottom",
                    position: "right",
                }).showToast();
                return false;
            }

            if (!dateCheck) {
                Toastify({
                    text: $(this).find(".content-item:nth-child(3)").data("message-text"),
                    duration: 2000,
                    newWindow: true,
                    close: true,
                    gravity: "bottom",
                    position: "right",
                }).showToast();
                return false;
            } else {
                $(".appointment-content button").attr("disabled", "disabled")
                return true;
            }
        })
    }
})